module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "face-page"
  }, [_c('div', {
    staticClass: "face-search",
    on: {
      "click": _vm.showUpPanel
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-panel",
    class: {
      'hidden': !_vm.showUpload
    }
  }, [_c('div', {
    staticClass: "panel",
    attrs: {
      "id": "faceRecog"
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('upload', {
    ref: "upload",
    attrs: {
      "pId": "face_con",
      "bId": "face_pic",
      "cb": _vm.uploaded
    }
  }, [_c('div', {
    staticClass: "qiniu",
    slot: "upload"
  }, [_c('img', {
    staticClass: "upload",
    attrs: {
      "width": "70%",
      "src": require("../../common/images/findmyself@2x.png"),
      "alt": ""
    }
  })])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-306abbee"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FaceRecog/FaceRecog.vue
// module id = 501
// module chunks = 1